import { ToggleButtonProps } from '@mui/material/ToggleButton';
import ToggleButtonGroup, {
  ToggleButtonGroupProps,
} from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import SwitchButton from '../atoms/SwitchButton';
import { FC } from 'react';

export type SwitchButtonItem = {
  value: any;
  label: any;
  onClick?(): void;
} & ToggleButtonProps;

export type SwitchProps = {
  items: SwitchButtonItem[];
  title?: any;
} & ToggleButtonGroupProps;

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(1),
  '&.Mui-disabled': {
    color: theme.palette.primary.main,
  },
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  display: 'flex',
  borderRadius: 6,
  backgroundColor: theme.palette.grey[300],
}));

const Switch: FC<SwitchProps> = ({
  items = [],
  title = '',
  exclusive = true,
  ...switchProps
}) => {
  return (
    <>
      {title && <StyledTitle>{title}</StyledTitle>}
      <StyledToggleButtonGroup {...switchProps} exclusive={exclusive}>
        {items.map(({ value, label, ...restButtonProps }) => (
          <SwitchButton key={value} value={value} {...restButtonProps}>
            {label}
          </SwitchButton>
        ))}
      </StyledToggleButtonGroup>
    </>
  );
};

export default Switch;
